import { FirebaseError } from "firebase/app";

// On web the Capacitor Firebase plugins delegate to the JS SDK and rethrow its
// `FirebaseError`; on native they reject with a plain error carrying the same `code`
// string. Reading the code structurally covers both.
export function getFirebaseErrorCode(error: unknown): string | undefined {
  if (error instanceof FirebaseError) return error.code;
  if (
    typeof error === "object" &&
    error !== null &&
    "code" in error &&
    typeof (error as { code: unknown }).code === "string"
  )
    return (error as { code: string }).code;
  return undefined;
}
